import Web3Utils from 'web3-utils';
import * as React from 'react';
import * as css from './TransferBlock.less';
import { ChangeEvent, FormEvent } from 'react';

interface FormProps {
  submit: (amount?: number, address?: string) => void
  onError: (error: string) => void
  disabled: boolean
  network: string
  balance: number
}

interface FormState {
  amount: string
  address: string
}

export default class TransferForm extends React.Component<FormProps, FormState> {
  constructor(props: FormProps) {
    super(props);

    this.state = {
      amount: '',
      address: ''
    };
  }

  handleAmount = (event: ChangeEvent<any>) => {
    this.setState({ amount: event.target.value });
  };

  handleAddress = (event: ChangeEvent<any>) => {
    this.setState({ address: event.target.value });
  };

  handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { submit, onError, network } = this.props;
    if (!network) {
      return onError('Unknown network!');
    }

    const { amount, address } = this.state;
    const value = Number(amount);
    if (isNaN(value)) {
      return onError('Incorrect DAT amount is entered!');
    }
    if (!address) {
      return onError('DAT address is required!');
    }
    if (!Web3Utils.isAddress(address)) {
      return onError('Incorrect DAT address is entered!');
    }

    submit(value, address);
    this.setState({amount: '', address: ''});
  };

  render() {
    const { amount, address } = this.state;
    const { disabled, network } = this.props;
    const isDatum = network === 'datum';
    const isDatumMegatron = network === 'datum-megatron';
    const isDatumNet = isDatum || isDatumMegatron;
    const isMainnet = network === 'mainnet';
    const isRinkeby = network === 'rinkeby';

    let btnText = 'Transfer DAT to ';
    if (isDatumNet) {
      btnText += (isDatumMegatron ? 'ETH Testnet' : 'ETH Network');
    } else if (isMainnet) {
      btnText += 'Datum Mainnet';
    } else {
      btnText += 'Datum Megatron';
    }

    return (
      <section className={css.transferBlock}>
        <ul>
          <li className={isMainnet ? css.activeTab : null}>Ethereum Network</li>
          <li className={isRinkeby ? css.activeTab : null}>Rinkeby Test Network</li>
          <li className={isDatum ? css.activeTab : null}>DAT Main Net Network</li>
          <li className={isDatumMegatron ? css.activeTab : null}>Megatron Test Network</li>
        </ul>
        <div className={css.details}>
          <div className={css.header}>
            <div className={css.infoCol}>
              {!isDatumNet && <span><strong>Ethereum</strong> {isMainnet ? 'Mainnet' : 'Rinkeby Testnet'}</span>}
              {isDatumNet && <span><strong>DAT</strong> {isDatum ? 'Mainnet' : 'Megatron Testnet'}</span>}
            </div>
            <div className={css.infoCol}>
              {!isDatumNet && <span style={{textAlign: 'right'}}><strong>DAT</strong> {isMainnet ? 'Mainnet' : 'Megatron Testnet'}</span>}
              {isDatumNet && <span style={{textAlign: 'right'}}><strong>Ethereum</strong> {isDatum ? 'Mainnet' : 'Rinkeby Testnet'}</span>}
            </div>
          </div>
          <form
            className={css.form}
            style={{marginTop: isMainnet ? '3rem' : '2rem'}}
            onSubmit={this.handleSubmit}
          >
            <div className="form-group">
              <input
                type="text"
                placeholder="0 DAT"
                className={css.control}
                value={amount}
                onChange={this.handleAmount}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                placeholder="Enter your address, e.g. 0x..."
                className={css.control}
                value={address}
                onChange={this.handleAddress}
              />
            </div>
            <input
              className={css.btnPrimary}
              type="submit"
              value={disabled ? 'Waiting for MetaMask...' : btnText}
              disabled={disabled}
            />
          </form>
        </div>
      </section>
    );
  }
}